export const rightPanelWidth = 340
export const leftPanelWidth = 400
